import { multiStep } from 'components/Wizards/MultiStepWizard/multiStep'
import { StepProps } from 'components/Wizards/MultiStepWizard/Types'
import { MultiStep } from '../MultiStepWizard/Step'
import { useGenerateSubjectLineOptions } from './SubjectLineSelection/useGenerateSubjectLineOptions'
import { SubjectLineValues } from './SubjectLineSelection/Types'
import {
  firstStepFields,
  newsletterMeta,
  topicFieldAnnouncement,
  topicFieldEditorial,
  topicFieldPromotional,
  topicFieldWeeklyUpdate,
} from '../schemas/EmailNewsletter'
import { useState } from 'react'
import { object } from 'yup'
import { StepSchema } from '../schemas/Types'
import { FormSchema } from '../Wizard/Form/Types'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { useSubjectLineOptions } from './SubjectLineSelection/SubjectLineOptionsProvider'

export const FirstStep = multiStep<StepProps>(({ onSubmit, ...props }) => {
  const { updateSubjectLineOptions } = useSubjectLineOptions()
  const generateSubjectLines = useGenerateSubjectLineOptions({ onCancel: props.onBack })
  const [fields, setFields] = useState(firstStepFields)

  const handleSubmit = (values: SubjectLineValues) => {
    updateSubjectLineOptions([])
    generateSubjectLines(values)

    return onSubmit({ ...values })
  }

  const formSchema = object(fields).meta(newsletterMeta) as FormSchema<ChannelType>
  const stepSchema = formSchema.meta({ submitLabel: 'Pick a Subject Line', title: 'Goals & Outline' }) as StepSchema

  const onChange = (values: any) => {
    const newsletterStyle = values?.newsletter_style

    if (newsletterStyle === 'Promotional') setFields({ ...firstStepFields, topic: topicFieldPromotional })
    if (newsletterStyle === 'Announcement') setFields({ ...firstStepFields, topic: topicFieldAnnouncement })
    if (newsletterStyle === 'Weekly Update') setFields({ ...firstStepFields, topic: topicFieldWeeklyUpdate })
    if (newsletterStyle === 'Editorial') setFields({ ...firstStepFields, topic: topicFieldEditorial })
  }

  return <MultiStep {...props} schema={stepSchema} onSubmit={handleSubmit} onChange={onChange} />
})
